<template>
    <ejs-dialog ref='queryDialog'
              :target='target'
              :isModal='isModal'
              :width='width'
              :header='header'
              :buttons='buttonGroup'
              :showCloseIcon='showCloseIcon'
              :animationSettings='animationSettings'
              v-bind:visible='visible'
              :content='cssClassContent'

              >
    </ejs-dialog>
</template>

<script>
export default {
    name:'queryDialog',
    props:{
        content:'',
    },
    data(){
        return{
            width: '280',//380
            visible: false,
            showCloseIcon: true,
            target: '#app',
            isModal:true,
            buttonGroup: [
              { click: this.close, buttonModel: { content: `${this.$t("Pm.cancel")}`} },
              { click: this.confirm, buttonModel: { content: `${this.$t("Pm.confirm")}` ,isPrimary: true } },

            ],
            header: `${this.$t("Pm.query")}`,
            animationSettings: { effect: 'None' },
            cssClassContent:"<div><div class='text'>"+this.content+"</div></div>",//<div class='toast-icons e-info erroricon'></div>
        }
    },
    methods:{
        show(){
            this.$refs.queryDialog.show();
        },
        close(){
            this.$refs.queryDialog.hide();
        },
        confirm(){
            this.$emit('confirm');
            this.$refs.queryDialog.hide();
        },
    },
    watch:{
        content:function(val){
            this.cssClassContent = "<div><div class='text'>"+val+"</div></div>";//<div class='toast-icons e-info erroricon'></div>
        }
    }

}
</script>

<style scoped>
.text{
  float:left !important;
  line-height:26px;
  width:230px
}
  .toast-icons {
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .toast-icons.e-success::before {
    content: "\e701";
  }

  .toast-icons.e-error {
    font-size: 30px !important;
    content: "\e700";
  }

  .toast-icons.e-info {
    font-size: 30px !important;
    content: "\e704";/*detailed \e704*/
    color: #e60000;
  }

  .toast-icons.e-warning {
    font-size: 30px !important;
    content: "\e703";
  }

  .erroricon{
    width: 30px !important;
    height: 30px !important;
    float: left;
    margin-right: 20px;
  }
  </style>
